'use client';
import Link from 'next/link';
import Image from 'next/image';
import { useTheme } from '@banzai/themes/use-theme';

export function InnerLayout({ children }: { children: React.ReactNode }) {
  const themeConfig = useTheme();

  return (
    <>
      <div className="container relative min-h-min h-full flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="relative hidden h-full flex-col bg-sidebar p-10 text-sidebar-foreground lg:flex dark:border-r">
          <div className="absolute inset-0 " />
          <div className="relative z-20 flex items-center text-lg font-medium">
            <Image
              alt={themeConfig.theme.logoAlt}
              src={themeConfig.theme.logoWhite}
              className="w-40"
            />
          </div>
          <div className="relative z-20 mt-auto">
            <blockquote className="space-y-2">
              <p className="text-lg">&ldquo;{themeConfig.theme.login.quote.text}&rdquo;</p>
              <footer className="text-sm">
                {themeConfig.theme.login.quote.author},<br />
                {themeConfig.theme.login.quote.role}
              </footer>
            </blockquote>
          </div>
        </div>
        <div className="lg:p-8 pt-12">
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
            {children}
            <p className="px-8 text-center text-sm text-muted-foreground">
              By clicking continue, you agree to our{' '}
              <Link
                href="https://www.banzai.io/legal/terms-and-conditions"
                className="underline underline-offset-4 hover:text-primary"
                target="_blank">
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link
                href="https://www.banzai.io/legal/privacy-policy"
                className="underline underline-offset-4 hover:text-primary"
                target="_blank">
                Privacy Policy
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
